import * as React from 'react';
import { useContext } from 'react';
import { isMobile } from 'react-device-detect';
import { MapStopDto } from '../../../api/UnitMap';
import '../../../styles/UnitMap.css';
import { MapContext } from './UnitMapTypes';
import UpArrow from '../../../images/up-carot-large.png';
import DownArrow from '../../../images/down-carot-large.png';

interface StopListProps {
    title: string;
}

const StopList = (props: StopListProps) => {
    const NumStopsToDisplay = 5;
    const context = useContext(MapContext);
    const [currentStop, setCurrentStop] = React.useState(0);
    const stopLabel = (stop: MapStopDto) => {
        if (stop.stopNumber === 0) {
            return (
                <span>
                    <b>Start:</b> {stop.description}
                </span>
            );
        }
        if (stop.stopNumber === context.configuration.stops.length - 1) {
            return (
                <span>
                    <b>End:</b> {stop.description}
                </span>
            );
        }
        return (
            <span>
                {stop.stopNumber}. {stop.description}
            </span>
        );
    };
    const showStop = (stopNumber: number): boolean => {
        if (!isMobile) {
            return true;
        }
        return stopNumber >= currentStop && stopNumber < currentStop + NumStopsToDisplay;
    };
    const showPrevStops = () => {
        if (!isMobile) {
            return false;
        }
        return currentStop > 0;
    };
    const showNextStops = () => {
        if (!isMobile) {
            return false;
        }
        return currentStop + NumStopsToDisplay < context.configuration.stops.length;
    };
    return (
        <div className={'d-flex flex-column legend'}>
            <h5>{props.title}</h5>
            <div className="d-flex px-2 justify-content-center">
                <p>
                    Tap <b>START</b> below to begin.
                </p>
            </div>

            {showPrevStops() && (
                <div
                    onClick={() => {
                        setCurrentStop(currentStop - NumStopsToDisplay);
                    }}
                    className={'stoplist-item'}
                >
                    <div className={'d-flex px-2 justify-content-center'}>
                        <img src={UpArrow} />
                    </div>
                </div>
            )}
            {context.configuration.stops
                .sort((a, b) => a.stopNumber - b.stopNumber)
                .map(stop => {
                    return (
                        showStop(stop.stopNumber) && (
                            <div
                                onClick={() => {
                                    context.selectFloor(stop.floor);
                                    context.selectStop(stop.stopNumber);
                                }}
                                className={'stoplist-item'}
                                key={stop.stopNumber}
                            >
                                <div className={'d-flex px-2'}>
                                    <div>{stopLabel(stop)}</div>
                                </div>
                            </div>
                        )
                    );
                })}
            {showNextStops() && (
                <div
                    onClick={() => {
                        setCurrentStop(currentStop + NumStopsToDisplay);
                    }}
                    className={'stoplist-item'}
                >
                    <div className={'d-flex px-2 justify-content-center'}>
                        <img src={DownArrow} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default StopList;



// WEBPACK FOOTER //
// ./src/components/common/UnitMap/StopList.tsx